var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsFargate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/64/Arch_AWS-Fargate_64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-fargate-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/64/Arch_AWS-Fargate_64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/64/Compute",
    fill: "url(#linearGradient-fargate-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/64/AWS-Fargate",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,48.523 L44,43.677 L47,42.477 L47,47.323 L44,48.523 Z M39,42.477 L42,43.677 L42,48.523 L39,47.323 L39,42.477 Z M33,55.523 L33,50.677 L36,49.477 L36,54.323 L33,55.523 Z M28,49.477 L31,50.677 L31,55.523 L28,54.323 L28,49.477 Z M22,48.523 L22,43.677 L25,42.477 L25,47.323 L22,48.523 Z M17,42.477 L20,43.677 L20,48.523 L17,47.323 L17,42.477 Z M21,40.077 L23.308,41 L21,41.923 L18.692,41 L21,40.077 Z M32,47.077 L34.308,48 L32,48.923 L29.692,48 L32,47.077 Z M43,40.077 L45.308,41 L43,41.923 L40.692,41 L43,40.077 Z M48.371,40.071 L43.371,38.071 C43.133,37.977 42.867,37.977 42.629,38.071 L37.629,40.071 C37.249,40.224 37,40.591 37,41 L37,46.923 L32.371,45.071 C32.133,44.977 31.867,44.977 31.629,45.071 L27,46.923 L27,41 C27,40.591 26.751,40.224 26.371,40.071 L21.371,38.071 C21.133,37.977 20.867,37.977 20.629,38.071 L15.629,40.071 C15.249,40.224 15,40.591 15,41 L15,48 C15,48.409 15.249,48.776 15.629,48.929 L20.629,50.929 C20.748,50.976 20.874,51 21,51 C21.126,51 21.252,50.976 21.371,50.929 L26,49.077 L26,55 C26,55.409 26.249,55.776 26.629,55.929 L31.629,57.929 C31.748,57.976 31.874,58 32,58 C32.126,58 32.252,57.976 32.371,57.929 L37.371,55.929 C37.751,55.776 38,55.409 38,55 L38,49.077 L42.629,50.929 C42.748,50.976 42.874,51 43,51 C43.126,51 43.252,50.976 43.371,50.929 L48.371,48.929 C48.751,48.776 49,48.409 49,48 L49,41 C49,40.591 48.751,40.224 48.371,40.071 L48.371,40.071 Z M57,27.938 C57,33.783 44.119,36.938 32,36.938 C19.881,36.938 7,33.783 7,27.938 C7,25.147 10.095,22.69 15.715,21.019 L16.285,22.936 C11.791,24.272 9,26.189 9,27.938 C9,31.249 18.445,34.938 32,34.938 C45.555,34.938 55,31.249 55,27.938 C55,26.189 52.209,24.272 47.715,22.936 L48.285,21.019 C53.905,22.69 57,25.147 57,27.938 L57,27.938 Z M32,9.071 L42.214,13 L32,16.929 L21.786,13 L32,9.071 Z M42.58,28.842 C40.694,29.686 37.528,30.669 33,30.801 L33,18.687 L44,14.457 L44,26.648 C44,27.599 43.444,28.46 42.58,28.842 L42.58,28.842 Z M20,26.648 L20,14.457 L31,18.687 L31,30.801 C26.472,30.669 23.306,29.686 21.416,28.84 C20.556,28.46 20,27.599 20,26.648 L20,26.648 Z M20.604,30.667 C22.805,31.652 26.569,32.827 32,32.827 C37.431,32.827 41.195,31.652 43.393,30.669 C44.977,29.968 46,28.39 46,26.648 L46,13 C46,12.586 45.745,12.215 45.359,12.066 L32.359,7.066 C32.127,6.978 31.873,6.978 31.641,7.066 L18.641,12.066 C18.255,12.215 18,12.586 18,13 L18,26.648 C18,28.39 19.023,29.968 20.604,30.667 L20.604,30.667 Z",
    id: "AWS-Fargate_Icon_64_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsFargate);
export default __webpack_public_path__ + "static/media/aws-fargate.b09663c21d484e12d871b2a1ddcdb090.svg";
export { ForwardRef as ReactComponent };